import { createFileRoute } from '@tanstack/react-router'
import DistribuicaoInteligentePage from '@/pages/dashboard/distribuicao-inteligente-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/distribuicao-inteligente',
)({
  component: function DistribuicaoInteligenteRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.LEADS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <DistribuicaoInteligentePage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
